// extracted by mini-css-extract-plugin
module.exports = {"caret":"styles__caret___VOJoF"};